import { ChevronLeftIcon, ChevronRightIcon } from '@repo/studio-design-system-ui-icons/arrows'
import { IconButton } from '@repo/studio-design-system-ui-button'
import type { ButtonSize } from '@repo/studio-design-system-ui-button'
import { tw } from 'utils/classnames'

import { StudioIconButton } from '@repo/studio-components-buttons/studio-button'
import type {
  StudioButtonVariant,
  StudioButtonSize,
} from '@repo/studio-components-buttons/studio-button'

type ScrollButtonVariant = StudioButtonVariant | 'overlay'
type ScrollButtonSize = StudioButtonSize | ButtonSize

function mapIconButtonSize(size: ScrollButtonSize): ButtonSize {
  if (size === 'tiny' || size === 'xs') {
    return 'xs'
  }
  if (size === 'small' || size === 'sm') {
    return 'sm'
  }
  return 'md'
}

const DS_VARIANT_MAP: Partial<
  Record<StudioButtonVariant, 'secondary' | 'ghost' | 'promotional' | 'danger'>
> = {
  gray: 'secondary',
  invisible: 'ghost',
  green: 'promotional',
  danger: 'danger',
}

export function ScrollButton({
  buttonHeight,
  variant,
  buttonVariant = 'gray',
  buttonSize = 'medium',
  onClick,
}: {
  variant: 'left' | 'right'
  buttonHeight: number
  buttonVariant?: ScrollButtonVariant
  buttonSize?: ScrollButtonSize
  onClick: () => void
}) {
  const dsVariant =
    buttonVariant === 'overlay' ? 'overlay' : DS_VARIANT_MAP[buttonVariant as StudioButtonVariant]

  return (
    <div
      className={tw(
        'absolute top-0 w-24 flex items-center pointer-events-none',
        variant === 'left' && 'left-0 justify-start',
        variant === 'right' && 'right-0 justify-end',
      )}
      style={{ height: buttonHeight }}
    >
      {dsVariant ? (
        <IconButton
          className="pointer-events-auto mx-4"
          size={mapIconButtonSize(buttonSize)}
          variant={dsVariant}
          onClick={onClick}
        >
          {variant === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      ) : (
        <StudioIconButton
          className="pointer-events-auto mx-4"
          size={buttonSize as StudioButtonSize}
          variant={buttonVariant as StudioButtonVariant}
          onClick={onClick}
        >
          {variant === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </StudioIconButton>
      )}
    </div>
  )
}
